import { DELETE_DISCOUNT_MASTER } from "../../types/DiscountMasterType";
import axios from "axios";
import { toast } from "react-toastify";

const deleteDiscountMasterAction = (id) => {
	return {
		type: DELETE_DISCOUNT_MASTER,
		payload: id,
	};
};

export const deleteDiscountMaster = (id) => {
	return async (dispatch) => {
		try {
			const { data } = await axios({
				method: "delete",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `discount-master/${id}`,
			});
			dispatch(deleteDiscountMasterAction(id));
			toast.success("Discount Master Deleted");
			return {
				message: "success",
			};
		} catch (error) {
			toast.error(error.response?.data?.error || "Error in deleting discount master");
			console.log(error.message);
		}
	};
};
